import { Controller } from "@hotwired/stimulus"
import { syncFilterChip } from "../utils/filter_chip"

// The memory timeline (memories/_timeline), behaving like a contact's
// Activity: a search and one filter chip (shared/_timeline_filter), month headings that hide with
// their rows, and - on a card - the first `limit` lines with "Show N more"
// revealing the rest in place. Right / Wrong live in memory_grade_controller,
// which the contact card's timeline uses too; a line it forgets tells this
// controller (memory-grade:forgotten) so the counts and months re-apply.
export default class extends Controller {
    static targets = ["chip", "trigger", "search", "row", "month", "empty", "more"]
    static values = { limit: Number }

    connect() {
        this.active = "all"
        this.expanded = !this.limitValue
        this.apply()
    }

    filterBy(event) {
        const next = event.currentTarget.dataset.source || "all"
        this.active = this.active === next ? "all" : next
        syncFilterChip(this.hasTriggerTarget ? this.triggerTarget : null, this.chipTargets, this.active)
        this.apply()
    }

    search() {
        this.apply()
    }

    showAll() {
        this.expanded = true
        this.apply()
    }

    apply() {
        const query = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
        const narrowed = this.active !== "all" || query
        const matches = this.rowTargets.filter((row) => {
            const tags = (row.dataset.filters || "").split(" ")
            return (this.active === "all" || tags.includes(this.active)) && (!query || (row.dataset.search || "").includes(query))
        })
        const cap = this.expanded || narrowed ? Infinity : this.limitValue
        const visible = new Set(matches.slice(0, cap))
        this.rowTargets.forEach((row) => (row.hidden = !visible.has(row)))
        const months = new Set([...visible].map((row) => row.dataset.month))
        this.monthTargets.forEach((month) => (month.hidden = !months.has(month.dataset.month)))
        if (this.hasEmptyTarget) this.emptyTarget.hidden = visible.size > 0
        if (this.hasMoreTarget) {
            const rest = matches.length - visible.size
            this.moreTarget.hidden = rest <= 0
            this.moreTarget.textContent = `Show ${rest} more`
        }
    }
}
